var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandSquareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_145_1",
    "data-name": "Component 145 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10548",
    "data-name": "Path 10548",
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z",
    fill: "#ecedf8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17889",
    "data-name": "Group 17889",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10601",
    "data-name": "Path 10601",
    d: "M27.911,9.672a.36.36,0,0,0-.136-.027H23.8a.357.357,0,1,0,0,.713h3.118l-5.4,5.4a.357.357,0,1,0,.5.5l5.4-5.4v3.118a.357.357,0,0,0,.713,0V10A.358.358,0,0,0,27.911,9.672Z",
    transform: "translate(-11.8 -3.727)",
    fill: "gray",
    stroke: "gray",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10602",
    "data-name": "Path 10602",
    d: "M19.316,16.186a.357.357,0,0,0-.357.357v3.8H8.973V10.358h3.81a.357.357,0,1,0,0-.713H8.617A.357.357,0,0,0,8.26,10V20.7a.357.357,0,0,0,.357.357h10.7a.357.357,0,0,0,.357-.357V16.542A.357.357,0,0,0,19.316,16.186Z",
    transform: "translate(-3.342 -3.727)",
    fill: "gray",
    stroke: "gray",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandSquareIcon);
export default __webpack_public_path__ + "static/media/expand-square-icon.b2476199cafc6baf6778ab14cce9d5b1.svg";
export { ForwardRef as ReactComponent };